{
  "app": {
    "create_view_label": "Company View",
    "read_only": "Read-only",
    "no_access_message": "You don't have access to this project. Please ask the person who shared the link with you to add you as a team member.",
    "search_no_results": "Cannot find app(s) with the title \"{{term}}\"",
    "no_apps_message": "There's no app for you, create one now",
    "view_table": "Table",
    "view_grid": "Grid",
    "get_started_message": "To get started, add your first list from the + button above on the left.",
    "unknown_tab_type": "Unknown tab type",
    "table": {
      "app_header": "App",
      "workspace_header": "Workspace",
      "team_members_header": "Team members"
    },
    "team_share": "Team/Share",
    "team": "Team"
  },
  "opportunities": {
    "form": {
      "header": "Opportunity",
      "company_label": "Select Associated Company *",
      "company_placeholder": "Type to search company",
      "status_label": "Status",
      "description_label": "Description",
      "description_placeholder": "Describe your opportunity in one sentence",
      "tags_label": "Tags",
      "proposed_fee_label": "Proposed Fee",
      "date_label": "Opportunity Date",
      "date_placeholder": "date",
      "internal_owner_label": "Internal Owner",
      "internal_owner_placeholder": "Who will be responsible for this opportunity?",
      "team_involved_label": "Team Involved",
      "team_involved_placeholder": "Team involved in this opportunity?",
      "referral_source_label": "Referral Source",
      "referral_source_placeholder": "Who referred this opportunity?"
    },
    "workspace": {
      "link_button": "Link Workspace",
      "link_modal_label": "Workspaces",
      "link_validation": "Please select a workspace",
      "unlink_title": "unlink opportunity from workspace",
      "unlink_confirmation": "Click confirm to unlink the opportunity from workspace",
      "unlink_confirm_title": "Are you sure you want to unlink this opportunity?",
      "actions": {
        "update": "Update",
        "unlink": "Unlink"
      },
      "custom_fields": {
        "section_header": "Workspace Columns"
      }
    },
    "actions": {
      "add_opportunity": "Add Opportunity",
      "add_column": "Add Column"
    }
  },
  "more_actions": {
    "manage_columns": "Manage Columns"
  }
}
